import containerFuild from '../html-snippets/container-fuild';
import css from '../tpl-css/style-section-card-grid-boxer';
const html = `
<div class="container">
  <div class="wrap-card">
    <div data-show="true" data-attribute="title-card" class="card-title">
      <h2 style="text-align: center;">4 Reasons Why</h2>
      <h3 style="text-align: center;">TitanBoxers Aren't Like Any Boxer You've Worn Before</h3>
      <p style="text-align: center;">
        If you've spent years settling for standard cotton or struggling with bulky "medical" solutions, your first day
        in an ICEMAX boxer will be a revelation. Here is why this isn't just an upgrade—it's a total reimagining of
        masculine foundation.
      </p>
    </div>
    <div
      data-background-stt="#606f99"
      data-color-stt="#FFFFFF"
      data-show-stt="true"
      data-space-between="30"
      data-col-perview="4"
      data-attribute="list-item"
      class="list-item"
      style="--col-perview: 4; --background-stt: #606f99; --color-stt: #FFFFFF; --space-between: 30px;"
    >
      <div data-attribute="item" class="wrap-item">
        <div class="wrap-img">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fa5c58032cc02672f24c.png"
            alt=""
          />
          <div data-attribute="stt-item" class="stt-item">1</div>
        </div>
        <div data-attribute="text-item" class="text-item">
          <h2>1. Invisible Leak Protection</h2>
          <p>
            You get total security against post-surgery drips or age-related leaks without the "crinkle" or bulk. No wet
            spots, no worries, just total dryness.
          </p>
        </div>
      </div>
      <div data-attribute="item" class="wrap-item">
        <div class="wrap-img">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fa62aac720edd7212d6d.png"
            alt=""
          />
          <div data-attribute="stt-item" class="stt-item">2</div>
        </div>
        <div data-attribute="text-item" class="text-item">
          <h2>2. Stay Dry, Stay Confident</h2>
          <p>
            Advanced moisture wicking technology keeps you fresh and dry, no matter how active your day gets. Comfort
            you can count on.
          </p>
        </div>
      </div>
      <div data-attribute="item" class="wrap-item">
        <div class="wrap-img">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fa6549839c56a574de6e.png"
            alt=""
          />
          <div data-attribute="stt-item" class="stt-item">3</div>
        </div>
        <div data-attribute="text-item" class="text-item">
          <h2>3. All Day Comfort Fit</h2>
          <p>
            Engineered with soft stretch fabric and a no-pinch waistband, TitanBoxers move with you for true all-day
            comfort.
          </p>
        </div>
      </div>
      <div data-attribute="item" class="wrap-item">
        <div class="wrap-img">
          <img
            data-attribute="image-item"
            src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fa696eed5d84bdcb7c68.png"
            alt=""
          />
          <div data-attribute="stt-item" class="stt-item">4</div>
        </div>
        <div data-attribute="text-item" class="text-item">
          <h2>4. Built to Last</h2>
          <p>
            Premium materials and reinforced stitching mean your TitanBoxers stay in shape wash after wash. Quality you
            can feel.
          </p>
        </div>
      </div>
    </div>
    <div class="wrap-cta">
      <a
        data-show="true"
        data-background-btn="#606f99"
        data-color-btn="#FFFFFF"
        data-radius-btn="6"
        href="#"
        data-attribute="btn"
        class="btn-more"
        style="background-color: #606f99; color: #FFFFFF; border-radius: 6px;"
      >
        <span data-attribute="btn-text">TRY IT TODAY, RISK-FREE !</span>
        <span class="icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <title>chevron-right</title>
            <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" fill="currentColor" />
          </svg>
        </span>
      </a>
      <div
        data-show="true"
        data-col-perview="2"
        data-attribute="policy-sub"
        class="policy-sub"
        style="--col-perview: 2;"
      >
        <div data-attribute="policy-item" class="policy-item">
          <div class="icon">
            <img
              data-attribute="icon-image"
              src="https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/05/25/image-6a14102101d90d908a5f9ce8.png?w=50&h=50&q=80"
              alt=""
            />
          </div>
          <div data-attribute="policy-text" class="policy-item-text">
            45-Day Money- Back Guarantee
          </div>
        </div>
        <div data-attribute="policy-item" class="policy-item">
          <div class="icon">
            <img
              data-attribute="icon-image"
              src="https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/05/25/image-6a1410257d4dd3d59ada2abf.png?w=50&h=50&q=80"
              alt=""
            />
          </div>
          <div data-attribute="policy-text" class="policy-item-text">
            Free Returns, No Questions Asked
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  topPadding: true,
  bottomPadding: true,
  backgroundColor: '#FFFFFF',
  textColor: '#000000',
});
